/* eslint-disable */
// R2D2 backend is deprecated — TRACK sagas still run for state/GTM side effects, but no request is sent.
export const trackAPI = _payload => Promise.resolve({});

export const gtmAPI = payload => window.dataLayer.push(payload);
export default {};
